import React, { useEffect, useState, useRef } from 'react'
import { useRouter } from 'next/router'
import Autocomplete from '@mui/material/Autocomplete';
import { Box, Card, CardContent, Divider, IconButton, Stack, TextField } from '@mui/material'
import Footer3 from '../../components/footer/footer-3'
import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import CircularProgress from '@mui/material/CircularProgress'
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VehicleCard from '../../components/VehicleCard';
import PaymentModes from "../../components/PaymentModesForHourly";
import CancelIcon from '@mui/icons-material/Cancel';
import ErrorPage from "../../components/PaymentModesForHourly/error_page";
// Redux
import { useDispatch, useSelector } from '../../redux/store'
import {
  getRentalCarList,
  createCarBooking,
  getSaveBooking,
  getRentalCarListNew,
  searchCar,
  searchCarFilter,
  searchRslCarFilter, getModelList
} from '../../redux/slices/product'
import { updateProfile } from '../../redux/slices/user'
import Header3 from '../../components/header/header-rslhome'
import Hero3 from '../../components/common/listServiceBannerImage'
import CarDropLocation from '../../components/hero/hero-rslhome/CarDropLocation'
import Image from 'next/image'
import moment from 'moment'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { Button, Grid, Paper, Typography } from '@mui/material'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import Slider from 'react-slick'
import Modal from '@mui/material/Modal'
import PickUpLocation from '../../components/goole-location/pickupLocation'
import { axiosInstance } from '../../utils/axiosInstance';
import Skeleton from '@mui/material/Skeleton'
import Head from 'next/head'
import { styled } from "@mui/material/styles";
import CarBookRideNew from '../../components/hero/hero-rslhome/CarBookRide';
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import CtaButton from '../../components/buttonWithArrow';
import { countries } from '../../data/countries';
import Seo from '../../components/common/Seo';
import { fetchSeoByPage } from '../../lib/seoHelper';

dayjs.extend(customParseFormat)

const dateFormat = 'YYYY-MM-DD'
const timeFormat = 'HH:mm:ss'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  // boxShadow: 24,
  p: 4,
  borderRadius: '20px'
}

const settings = {
  // dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4.5,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1030,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true
        // dots: true
      }
    },
    {
      breakpoint: 780,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    }
  ]
}

function countryToFlag(isoCode) {
  return typeof String.fromCodePoint !== 'undefined'
    ? isoCode
      .toUpperCase()
      .replace(/./g, char =>
        String.fromCodePoint(char.charCodeAt(0) + 127397)
      )
    : isoCode
}

/** 221 × 175 soft card with top haze and selected gradient ring */
const SoftCard = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "selected",
})(({ selected }) => ({
  position: "relative",
  width: 200,
  height: 160,
  borderRadius: 19,
  padding: 12,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  overflow: "hidden",
  transition: "transform .18s ease, box-shadow .18s ease",
  backgroundColor: "#EEF0EF",
  border: "1px solid #E7EEF0",
  boxShadow: "0 2px 10px rgba(0,0,0,.06)",


  /* top inner haze */
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "inherit",
    background:
      "linear-gradient(to bottom, rgba(15,127,138,.16) 0%, rgba(15,127,138,.06) 12%, rgba(15,127,138,0) 28%)",
    pointerEvents: "none",
  },

  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 6px 18px rgba(0,0,0,.10)",
  },

  /* selected gradient ring */
  ...(selected && {
    border: "2px solid transparent",
    backgroundImage:
      "linear-gradient(#EEF0EF, #EEF0EF), linear-gradient(180deg, #75c4c5 0%, #0d8196 100%)",
    backgroundOrigin: "border-box",
    backgroundClip: "padding-box, border-box",
    boxShadow: "0 6px 20px rgba(0,0,0,.10)",
  }),
}));

/** Image fits nicely inside 221×175 card */
const CarImage = styled("img")(() => ({
  display: "block",
  width: "100%",
  maxWidth: 210,      // keeps margins around the car
  height: 180,        // balanced for 175px card height
  objectFit: "contain",
}));

function CarouselItem({
  item,
  index,
  indx,
  setIndx,
  setGetModelId,
  getModelId,
  modelList
}) {
  const { model_name, _id } = item;
  const isSelected = _id === getModelId;

  return (
    // wrapper keeps label perfectly aligned to card width
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", width: 200, px: 1, pt: 2 }}>
      <SoftCard
        elevation={0}
        selected={isSelected}
        onClick={() => {
          setIndx(index);
          setGetModelId(_id);
        }}
      >
        <CarImage
          alt={model_name}
          src={isSelected ? modelList?.focus_image : modelList?.unfocus_image}
        />
      </SoftCard>

      <Typography
        sx={{
          mt: 1,
          textAlign: "center",
          fontSize: 14,
          fontWeight: isSelected ? 700 : 500,
          color: "#0A0A0A",
          width: "100%",
        }}
      >
        {model_name}
      </Typography>
    </Box>
  );
}

function splitDateTime(datetimeStr, label, { addHours = 0, encodeTime = true } = {}) {
  // Accept "YYYY-MM-DDTHH:mm" or "YYYY-MM-DDTHH:mm:ss"
  const [datePart, timePartRaw] = String(datetimeStr).trim().split(/[T\s]/);
  if (!datePart || !timePartRaw) throw new Error("Invalid datetime format (expected YYYY-MM-DDTHH:mm[:ss])");

  const [y, m, d] = datePart.split("-").map(Number);

  // Strip anything after seconds (e.g., timezone suffix) and ensure seconds
  const cleanTime = timePartRaw.replace(/(Z|[+-]\d{2}:?\d{2})$/, "");
  let [hh, mm, ss = "00"] = cleanTime.split(":");
  hh = Number(hh); mm = Number(mm); ss = Number(ss);

  // Build local date
  const dt = new Date(y, m - 1, d, hh, mm, ss);
  if (addHours) dt.setHours(dt.getHours() + addHours); // e.g. addHours = 4

  const pad = (n) => String(n).padStart(2, "0");

  const outDate = `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;
  const outTimeRaw = `${pad(dt.getHours())}:${pad(dt.getMinutes())}:${pad(dt.getSeconds())}`;
  const outTime = encodeTime ? encodeURIComponent(outTimeRaw) : outTimeRaw;

  return String(label).toLowerCase() === "time" ? outTime : outDate;
}

const safeParseJSON = (key) => {
  try {
    const data = sessionStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (err) {
    console.error(`Error parsing sessionStorage key: ${key}`, err);
    return null;
  }
};

// helpers
const pad = (n) => String(n).padStart(2, "0");
const toLocalInputValue = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
const addMinutes = (d, mins) => new Date(d.getTime() + mins * 60 * 1000);
const roundToStep = (d, step = 15) => {
  const m = d.getMinutes();
  const rounded = Math.ceil(m / step) * step;
  d.setMinutes(rounded, 0, 0);
  return d;
};

const STEP_MIN = 15;
// const getMinDateTime = () => toLocalInputValue(roundToStep(addMinutes(new Date(), 240), STEP_MIN));

const getMinDateTime = () => toLocalInputValue(addMinutes(new Date(), 240));

const CarBookRide = ({ meta }) => {
  const dispatch = useDispatch()
  const autocompleteFirst = useRef();
  const ref0 = useRef()
  const carouselRef = useRef()
  const router = useRouter()
  const apiKey = process.env.MAPKEY;
  const {
    pick_up,
    drop_off,
    pickup_Latlng,
    drop_Latlng,
    date,
    time,
    distance_main,
    model_id,
    modelIdget, rideBooking,
    productId,
    name, hourly
  } = router.query;
  const [hourlyValue, setHourlyValue] = useState(null);
  const [dateTime, setDateTime] = useState(getMinDateTime());

  const { saveBooking, rslCarSearchFilterRes, modelListRes } = useSelector(
    state => state.product
  )
  const { updateDetail } = useSelector(state => state.user)

  const [guestSearch, setGuestSearch] = useState('2')
  // const { cityName, pickupDateTime, dropDateTime } = router.query;
  const [defaultCode, setDefaultCode] = useState()

  const currentPath = router.asPath

  const [pickUpLocat, setPickUpLocat] = useState('')
  const [dropOffLocation, setDropOffLocation] = useState('')

  // -----------------------------------------------------
  const [pickup, setPickup] = useState('')
  const [drop, setDrop] = useState('')
  const [pickupLatlng, setPickupLatlng] = useState({
    lat: '',
    lng: ''
  })
  const [dropLatlng, setDropLatlng] = useState({
    lat: '',
    lng: ''
  })

  const [distance, setDistance] = useState('')
  const [duration, setDuration] = useState('')
  const [singleDate, setSingleDate] = useState(moment().format('YYYY-MM-DD'))
  const [timeValue1, setTimeValue1] = useState(moment().format('HH:mm:ss'))
  const [indx, setIndx] = useState(0)
  const [getModelId, setGetModelId] = useState(1)
  // -----------------------------------------------------
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [paymentMode, setPaymentMode] = useState("1");
  const [transRef, setTransRef] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [userId, setUserId] = useState('')
  const [distanceVal, setDistanceVal] = useState('')
  const [click, setClick] = useState(false)
  const [loader, setLoder] = useState(true)
  const [activityType, setActivityType] = useState([])
  const [filterData, setFilterData] = useState([])
  const [locationPopup, setLoactionPopup] = useState(false)
  const [priceData, setPriceData] = useState({
    min: 0,
    max: 0
  })
  const [priceData1, setPriceData1] = useState({
    min: 0,
    max: 0
  })
  const [dropDateTimeVal, setDropDateTimeVal] = useState('')
  const [timeValue, setTimeValue] = useState('')
  const [searchProduct, setSearchProduct] = useState('')
  const [selectedValue, setSelectedValue] = useState('')
  const [checkInDate, setCheckInDate] = useState('')
  const [checkOutDate, setCheckOutDate] = useState('')
  const [rentalCarListDetails, setRentalCarListDetails] = useState([])
  const [values, setValues] = useState([])
  const [messages, setMessages] = useState('No suitable cars found')
  const [userNumber, setUserNumber] = useState({
    countryCode: '971',
    number: ''
  })
  const [dayDifference, setDayDifference] = useState(null)
  const [bookingLoader, setBookingLoader] = useState(false);
  const [price, setPrice] = useState(0);
  const [getDetails, setGetDetails] = useState(null);
  const [bookingIndex, setBookingIndex] = useState(null)
  const [currentButton, setCurrentButton] = useState(null)
  const [serachBtn, setSerachBtn] = useState(false)
  const [open, setOpen] = useState(false)
  const [openLocation, setOpenLocation] = useState(false)
  const [filterDataOne, setFilterDataOne] = useState({
    type: 1,
    seat: '',
    gearShift: '',
    distance: distance,
    payment: '',
    corporate_id: 0,
    pickup_latitude: 0.0,
    pickup_longitude: 0.0,
    drop_latitude: 0.0,
    drop_longitude: 0.0,
    company_id: 0,
    model_id: 1
  })

  const [isPriceChange, setIsPriceChange] = useState(false)
  const [loading, setLoading] = useState(true)
  const [isFilter, setIsFilter] = useState(false)

  const [selectedIndex, setSelectedIndex] = useState(null)
  const [selectedModel, setSelectedModel] = useState(null)
  const [selectedModelPrice, setSelectedModelPrice] = useState(null)
  const [selectedActualPrice, setSelectedActualPrice] = useState(null)
  const [modelList, setModelList] = useState([]);
  const [modelListLoader, setModelListLoader] = useState(true);
  const [focusNext, setFocusNext] = useState(false)
  const [selectedModelName, setSelectedModelName] = useState('')

  const [polylineArray, setPolylineArray] = useState([])
  const [polyline, setPolyline] = useState("");

  // useEffect(() => {
  //   if (autocompleteFirst.current) {
  //     autocompleteFirst.current.querySelector('input').focus();
  //   }
  // }, []);

  const handleClose = () => {
    setOpen(false)
    setBookingLoader(false)
    setSelectedModel(null)
    setSelectedModelPrice(null);
    setSelectedActualPrice(null);
    setSelectedIndex(null)
  }
  const handleCloseLocation = () => {
    setOpenLocation(false)
  }

  useEffect(() => {
    if (modelIdget) {
      setGetModelId(parseInt(modelIdget, 10))
      setLoder(false)
      setLoactionPopup(true)
    }
  }, [modelIdget])

  useEffect(() => {
    if (rideBooking) {
      setLoder(false)
      setLoactionPopup(true)
    }
  }, [rideBooking])

  useEffect(() => {
    setPickup(pick_up)
    setDrop(drop_off)
    setPickupLatlng({
      lat: '',
      lng: ''
    })
    setDropLatlng({
      lat: '',
      lng: ''
    })
    setDistance(distance_main)
    setDuration()

    if (modelIdget) {
      setGetModelId(parseInt(modelIdget, 10))
      setLoder(false)
      setLoactionPopup(true)
    }

    setValues([]);
    if (hourly) {
      setHourlyValue(Number(hourly) || null);
    }

    if (date && time) {
      const formattedTime = dayjs(time, 'HH:mm:ss').format('HH:mm:ss')
      const formattedDate = dayjs(date).format('YYYY-MM-DD')
      const merged = dayjs(`${formattedDate} ${formattedTime}`, "YYYY-MM-DD HH:mm:ss");
      // as string (local)
      const mergedStr = merged.format("YYYY-MM-DD HH:mm:ss");
      // ISO-like (local)
      const mergedIsoLocal = merged.format("YYYY-MM-DD[T]HH:mm:ss");
      // true ISO (UTC)
      const mergedIsoUtc = merged.toDate().toISOString();
      setDateTime(mergedIsoLocal)

      setSingleDate(formattedDate)
      setTimeValue1(formattedTime)
    }
  }, [router.query])

  const checkValidation = (parsedPickup, parsedDrop) => {
    if (hourly) {
      return getModelId !== '' &&
        (pickupLatlng?.lat || parsedPickup?.lat) &&
        (pickupLatlng?.lng || parsedPickup?.lng)
    }
    return getModelId !== '' &&
      (pickupLatlng?.lat || parsedPickup?.lat) &&
      (pickupLatlng?.lng || parsedPickup?.lng) &&
      (dropLatlng?.lat || parsedDrop?.lat) &&
      (dropLatlng?.lng || parsedDrop?.lng)
  }

  const checkNewValidation = (pickupLatlng, dropLatlng) => {
    if (hourly) {
      return pickupLatlng?.lat && pickupLatlng?.lng
    }
    return pickupLatlng?.lat && pickupLatlng?.lng && dropLatlng?.lat && dropLatlng?.lng
  }

  useEffect(() => {
    if (locationPopup) {
      return
    }

    const safeParse = value => {
      try {
        return value ? JSON.parse(value) : null
      } catch (error) {
        console.error('Invalid JSON:', value)
        return null
      }
    }

    const parsedPickup = safeParse(pickup_Latlng)
    const parsedDrop = safeParse(drop_Latlng)
    if (checkNewValidation(pickupLatlng, dropLatlng)) {
      if (
        checkValidation(parsedPickup, parsedDrop)
      ) {
        setLoder(true)
        dispatch(
          searchRslCarFilter({
            corporate_id: 0,
            pickup_latitude: pickupLatlng?.lat || parsedPickup?.lat,
            pickup_longitude: pickupLatlng?.lng || parsedPickup?.lng,
            drop_latitude: dropLatlng?.lat || parsedDrop?.lat,
            drop_longitude: dropLatlng?.lng || parsedDrop?.lng,
            company_id: 0,
            distance: distance || distance_main,
            model_id: parseInt(getModelId, 10) || getModelId,
            seat: '',
            gearShift: '',
            overview_polyline: polylineArray || [],
            hours: hourlyValue,
            is_hourly: hourlyValue ? 1 : null
          })
        )
      } else {
        setLoder(false)
        setLoactionPopup(true)
      }
    }
  }, [getModelId, pickupLatlng, dropLatlng, distance, hourly, locationPopup])

  // useEffect(() => {
  //   handleSearchIcon();
  // }, []);

  const handleSearchIcon = () => {
    setValues([])
    setLoder(true)
    dispatch(
      searchRslCarFilter({
        corporate_id: 0,
        pickup_latitude: pickupLatlng.lat,
        pickup_longitude: pickupLatlng.lng,
        drop_latitude: dropLatlng.lat,
        drop_longitude: dropLatlng.lng,
        company_id: 0,
        distance: distance,
        model_id: parseInt(getModelId, 10)
          ? parseInt(getModelId, 10)
          : getModelId,
        seat: '',
        gearShift: '',
        overview_polyline: polylineArray || [],
        hours: hourlyValue,
        is_hourly: hourlyValue ? 1 : null
      })
    )
  }

  useEffect(() => {
    if (rslCarSearchFilterRes) {
      setMessages(rslCarSearchFilterRes?.message)
      setValues(rslCarSearchFilterRes?.responseData)
      calculateDayDifference()
      setLoder(false)
    }
    //  else {
    //   setValues([]);
    //   setLoder(false);
    // }
  }, [rslCarSearchFilterRes])

  useEffect(() => {
    setUserId(safeParseJSON('rslkey'))
    dispatch(searchCarFilter())
    setModelListLoader(true);
    dispatch(getModelList())
  }, [])

  useEffect(() => {
    if (modelListRes) {
      setModelListLoader(false);
      if (modelListRes?.status === 1) {
        setModelList(modelListRes?.responseData?.modelsList || []);
      } else {
        setModelList([]);
      }
    }
  }, [modelListRes])

  // useEffect(() => {
  //   if (saveBooking.status) {
  //     setBookingLoader(false)
  //     router.push({
  //       pathname: '/bookinginfo',
  //       query: {
  //         saveBooking: saveBooking?.status,
  //         message: saveBooking?.message,
  //         detail: saveBooking?.detail?.passenger_tripid
  //       }
  //     })
  //   }
  // }, [saveBooking])

  useEffect(() => {
    if (saveBooking && bookingLoader) {
      setBookingLoader(false);

      if (saveBooking?.status !== 1) {
        setErrorMessage(saveBooking?.message || "Something went wrong!");
      }
      else if (saveBooking?.paymentUrl && saveBooking?.paymentUrl !== "") {
        sessionStorage.setItem("activityTypes", 21);
        sessionStorage.setItem("ref", saveBooking?.orderReference);
        sessionStorage.setItem("carTripIs", saveBooking?.tripId);
        sessionStorage.setItem("activityTypes", 21);
        router.push(saveBooking?.paymentUrl);
      } else {
        router.push({
          pathname: '/bookinginfo',
          query: {
            saveBooking: saveBooking?.status,
            message: saveBooking?.message,
            detail: saveBooking?.detail?.passenger_tripid,
            isPersonalChauffeur: saveBooking?.detail?.isPersonalChauffeur,
            planName: saveBooking?.detail?.planName ?? null,
            validTo: saveBooking?.detail?.validity?.label ?? null,
          }
        })
      }

    }
  }, [saveBooking])

  const handleCurrency = () => {
    setClick(prevState => !prevState)
    // router.push("/sign-in/sign-in");
    sessionStorage.setItem('bookingPath', currentPath)
  }

  function handleConfirmBooking(index, selectedModel, price, actualPrice) {
    if (pickupLatlng.lan !== '' && pickupLatlng.lng !== '') {
      if (
        safeParseJSON('rslkeyId') &&
        safeParseJSON('rslkey') &&
        safeParseJSON('phone')
      ) {
        setSelectedModel(selectedModel);
        setSelectedModelPrice(price ?? null);
        setSelectedActualPrice(actualPrice ?? null);
        setSelectedIndex(index)
        setOpen(true)
      } else {
        handleCurrency()
        setOpen(false)
      }
      // alert(selectedModel);
    } else {
      setOpenLocation(true)
    }
  }

  function handleBooking() {
    if (pickupLatlng.lan !== '' && pickupLatlng.lng !== '') {
      if (
        safeParseJSON('rslkeyId') &&
        safeParseJSON('rslkey') &&
        safeParseJSON('phone')
      ) {
        if (hourly) {
          setOpen(false);

          setPaymentOpen(true);
          setPrice(selectedActualPrice);
        } else {
          setBookingLoader(true)
          dispatch(
            getSaveBooking({
              phone: safeParseJSON('phone'),
              countryCode: safeParseJSON('countryCode'),
              name: safeParseJSON('userName'),
              email: safeParseJSON('userEmail'),
              userId: safeParseJSON('rslkey'),
              passenger_id: safeParseJSON('rslkeyId'),
              type: 0,
              latitude: pickupLatlng.lat,
              longitude: pickupLatlng.lng,
              pickupplace: pickup,
              motor_model: selectedModel,
              drop_latitude: dropLatlng.lat,
              drop_longitude: dropLatlng.lng,
              pickup_time: `${splitDateTime(dateTime, "date")} ${splitDateTime(dateTime, "time", { encodeTime: false })}`,
              dropplace: drop,
              now_after: '1',
              approx_distance: distance ? distance : '0',
              approx_duration: duration ? duration : '0',
              passenger_payment_option: 1,
              payment_mode: paymentMode,
              route_polyline: polyline,
              // approx_trip_fare: '0.0',
              cityname: '',
              distance_away: 0,
              drop_makani: '',
              drop_notes: '',
              fav_driver_booking_type: 0,
              friend_id2: 0,
              friend_id3: 0,
              friend_id4: 0,
              friend_percentage1: 100,
              friend_percentage2: 0,
              friend_percentage3: 0,
              friend_percentage4: 0,
              guest_name: '',
              guest_phone: '',
              is_guest_booking: '0',
              notes: '',
              passenger_app_version: '9.4.6',
              pickup_makani: '',
              pickup_notes: '',
              promo_code: '',
              request_type: '1',
              sub_logid: '',
              web_booking: 1,
              requested_trip_hour: hourlyValue,
              hourly_fare: hourlyValue ? selectedModelPrice : null,
              approx_trip_fare: selectedActualPrice
            })
          )
        }
      } else {
        handleCurrency()
        setOpen(false)
      }
    } else {
      alert('Please, select the pickup location')
    }
  }

  const handleCardOption = () => {
    if (pickupLatlng.lan !== '' && pickupLatlng.lng !== '') {
      if (
        safeParseJSON('rslkeyId') &&
        safeParseJSON('rslkey') &&
        safeParseJSON('phone')
      ) {
        setBookingLoader(true)
        dispatch(
          getSaveBooking({
            phone: safeParseJSON('phone'),
            countryCode: safeParseJSON('countryCode'),
            name: safeParseJSON('userName'),
            email: safeParseJSON('userEmail'),
            userId: safeParseJSON('rslkey'),
            passenger_id: safeParseJSON('rslkeyId'),
            type: 0,
            latitude: pickupLatlng.lat,
            longitude: pickupLatlng.lng,
            pickupplace: pickup,
            motor_model: selectedModel,
            drop_latitude: dropLatlng.lat,
            drop_longitude: dropLatlng.lng,
            pickup_time: `${splitDateTime(dateTime, "date")} ${splitDateTime(dateTime, "time", { encodeTime: false })}`,
            dropplace: drop,
            now_after: '1',
            approx_distance: distance ? distance : '0',
            approx_duration: duration ? duration : '0',
            passenger_payment_option: 1,
            payment_mode: paymentMode,
            transRef: transRef,
            route_polyline: polyline,
            // approx_trip_fare: '0.0',
            cityname: '',
            distance_away: 0,
            drop_makani: '',
            drop_notes: '',
            fav_driver_booking_type: 0,
            friend_id2: 0,
            friend_id3: 0,
            friend_id4: 0,
            friend_percentage1: 100,
            friend_percentage2: 0,
            friend_percentage3: 0,
            friend_percentage4: 0,
            guest_name: '',
            guest_phone: '',
            is_guest_booking: '0',
            notes: '',
            passenger_app_version: '9.4.6',
            pickup_makani: '',
            pickup_notes: '',
            promo_code: '',
            request_type: '1',
            sub_logid: '',
            web_booking: 1,
            requested_trip_hour: hourlyValue,
            hourly_fare: hourlyValue ? selectedModelPrice : null,
            approx_trip_fare: selectedActualPrice
          })
        )

      } else {
        handleCurrency()
        setOpen(false)
      }
    } else {
      alert('Please, select the pickup location')
    }
  }

  const handleClearFilter = () => {
    setPriceData(priceData1)
    setActivityType([])
    const obj = {
      carId: productId,
      pickupLocation: selectedValue?.cityName,
      name: selectedValue?.name,
      pickupDate: checkInDate,
      pickupTime: timeValue,
      priceRange: priceData1,
      filter: []
    }
    setValues([])
    setLoder(true)
    dispatch(getRentalCarListNew(obj))
  }

  const calculateDayDifference = () => {
    const startMoment = moment(checkInDate)
    const endMoment = moment(checkOutDate)

    const dayDiff = endMoment.diff(startMoment, 'days')

    setDayDifference(dayDiff)
  }

  const handlePrevious = () => {
    carouselRef.current.slickPrev()
  }

  const handleNext = () => {
    carouselRef.current.slickNext()
  }

  useEffect(() => {
    if (pickup && pickup !== '') {
      componentDidMountPickup()
    }
  }, [pickup])

  useEffect(() => {
    if (drop && drop !== '') {
      componentDidMountDrop()
    }
  }, [drop])

  useEffect(() => {
    if (pickup && drop && pickup !== '' && drop !== '') {
      //   // getRouteDistanceAndDuration(pickup,drop);
      calculateDistanceAndDuration(pickup, drop)
    }
  }, [pickup, drop, window.google])

  useEffect(() => {
    const durationInHours = Math.ceil(duration / 60);
    const firstEnabled = Array.from({ length: 12 }, (_, i) => i + 1).find((h) => {
      const shouldDisable = duration < 60 ? false : h <= durationInHours;
      return !shouldDisable;
    });

    if (hourly) {
      if (firstEnabled && (pick_up !== pickup || drop_off !== drop)) {
        setHourlyValue(firstEnabled);
      } else {
        setHourlyValue(Number(hourly))
      }
    }
  }, [duration]);

  const decodePolyline = encoded => {
    let points = []
    let index = 0,
      lat = 0,
      lng = 0

    while (index < encoded?.length) {
      let b,
        shift = 0,
        result = 0
      do {
        b = encoded.charCodeAt(index++) - 63
        result |= (b & 0x1f) << shift
        shift += 5
      } while (b >= 0x20)
      let deltaLat = result & 1 ? ~(result >> 1) : result >> 1
      lat += deltaLat

      shift = 0
      result = 0
      do {
        b = encoded.charCodeAt(index++) - 63
        result |= (b & 0x1f) << shift
        shift += 5
      } while (b >= 0x20)
      let deltaLng = result & 1 ? ~(result >> 1) : result >> 1
      lng += deltaLng

      points.push({ lat: lat / 1e5, lng: lng / 1e5 })
    }

    return points
  }

  const calculateDistanceAndDuration = (origin, destination) => {
    if (!window.google || !window.google.maps) {
      console.error('Google Maps API is not loaded yet.')
      return
    }
    const directionsService = new window.google.maps.DirectionsService()

    directionsService.route(
      {
        origin: origin,
        destination: destination,
        travelMode: window.google.maps.TravelMode.DRIVING
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          // setDirections(result);
          const route = result.routes[0];
          var temp2 = 0;

          route.legs.map((item) => {
            if (item.duration.text.split(' ').length === 2) {
              temp2 = temp2 + parseInt(item.duration.text.split(' ')[0]);
            }

            if (item.duration.text.split(' ').length === 4) {
              temp2 =
                temp2 +
                parseInt(item.duration.text.split(' ')[0]) * 60 +
                parseInt(item.duration.text.split(' ')[2]);
            }
          });
          // setDuration(result.routes[0].legs[0].duration.text)
          setDuration(temp2);
          setDistance(result.routes[0].legs[0].distance.text)

          if (result.routes && result.routes.length > 0) {
            const route = result.routes[0]

            if (route && route?.overview_path) {
              setPolylineArray(route?.overview_path)
              setPolyline(route?.overview_polyline)
            }
          } else {
            console.error('Error: `overview_polyline` not found in response.')
          }
        } else {
        }
      }
    )
  }

  const componentDidMountPickup = async () => {
    const response = await axiosInstance.get(
      `${process.env.BACKEND_URL}/location/geocode?address=${pickup}`
    )

    // const response = await axios.get(
    //   `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
    //     pickup
    //   )}&key=${apiKey}`
    // )

    const { results } = response.data
    if (results && results.length > 0) {
      const { lat, lng } = results[0].geometry.location
      setPickupLatlng({
        ...pickupLatlng,
        ['lat']: lat ? lat : 0,
        ['lng']: lng ? lng : 0
      })
    } else {
      setPickupLatlng({
        lat: '',
        lng: ''
      })
    }
  }
  const componentDidMountDrop = async () => {
    const response = await axiosInstance.get(
      `${process.env.BACKEND_URL}/location/geocode?address=${drop}`
    )

    // const response = await axios.get(
    //   `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
    //     drop
    //   )}&key=${apiKey}`
    // )

    const { results } = response.data
    if (results && results.length > 0) {
      const { lat, lng } = results[0].geometry.location
      setDropLatlng({
        ...dropLatlng,
        ['lat']: lat ? lat : 0,
        ['lng']: lng ? lng : 0
      })
    } else {
      setDropLatlng({
        lat: '',
        lng: ''
      })
      return null
    }
  }

  const handleChange = (e, countryCode = '') => {
    if (countryCode) {
      setUserNumber({ ...userNumber, countryCode: countryCode })
    } else {
      const { name, value } = e.target

      setUserNumber({ ...userNumber, [name]: value })
    }

    // setValidate(false);
  }

  const handleUpdate = () => {
    const obj = {
      rslId: safeParseJSON('rslkeyId'),
      email: safeParseJSON('userEmail'),
      countryCode: userNumber?.countryCode,
      phone: userNumber?.number,
      name: safeParseJSON('userName'),
      type: '0',
      dateOfBirth: '',
      gender: ''
    }

    dispatch(updateProfile(obj))
  }

  useEffect(() => {
    if (updateDetail) {
      if (updateDetail.status) {
        setClick(false)
        // setBookingLoader(true);
        // alert("Profile Updated Successfully");
        // handleBooking();.
        sessionStorage.setItem('phone', updateDetail?.responseData?.mobile)
        sessionStorage.setItem(
          'countryCode',
          updateDetail?.responseData?.countryCode
        )
      }
    }
  }, [updateDetail])

  useEffect(() => {
    const getName = modelList?.filter(car => getModelId === car?._id)
    setSelectedModelName(getName[0]?.model_name)
  }, [getModelId, modelList])

  const handleCloseLocationPopup = () => setLoactionPopup(false);
  const handleCancelPayment = () => {
    setPaymentOpen(false);
    setPaymentMode("1");
  }

  return (
    <>
      <Seo noIndex={true} />
      <Header3 bgColor="#EBEBEB" borderColor="#DFDFDF" />
      <Box
        style={{
          // backgroundColor: '#fcfcfc'
          backgroundImage: "url('/img/banner/grid.svg')"
        }}
        className={`carbookride_margin_top`}
        sx={{
          '& .MuiInputBase-root': {
            '&:before': {
              borderBottom: 'transparent'
            },
            '&:hover': {
              borderBottom: 'transparent'
            }
          }
        }}
      >
        <CarBookRideNew duration={duration} pickup={pickup} hourly={hourlyValue} setHourly={setHourlyValue} setPickup={setPickup} drop={drop} setDrop={setDrop} dateTime={dateTime} setDateTime={setDateTime} handleSearchIcon={handleSearchIcon} />

        {/* location popup start */}
        <Modal
          // keepMounted
          open={locationPopup}
          // onClose={handleCloseLocationPopup}
          aria-labelledby='keep-mounted-modal-title'
          aria-describedby='keep-mounted-modal-description'
        >
          <Box sx={style} className='location-popup'>
            <Box position='absolute' top={10} right={10}>
              <CloseIcon
                sx={{ cursor: 'pointer' }}
                onClick={() => router.push('/')}
              />
            </Box>
            <Typography
              id='keep-mounted-modal-title'
              variant='h6'
              component='h2'
            >
              📍Provide Your Location Details
            </Typography>
            <Typography id='keep-mounted-modal-description'>
              To find the best ride options for you, please provide your
              **pickup and drop-off locations**.
            </Typography>
            <div className='input-location'>
              <PickUpLocation
                type={'pickup'}
                pickup={pickup}
                label='Pickup Location'
                placeholder='Search'
                setLoading={setLoading}
                loading={loading}
                autocompleteFirst={autocompleteFirst}
                setPickup={mPickUp => {
                  setPickup(mPickUp)
                }}
                setDrop={mDrop => {
                  setDrop(mDrop)
                }}
              // pick_up={pick_up}
              />
            </div>

            <div className='input-location'>
              <PickUpLocation
                type={'drop'}
                drop={drop}
                label='Drop Location'
                placeholder='Search'
                setLoading={setLoading}
                loading={loading}
                focusNext={focusNext}
                setPickup={mPickUp => {
                  setPickup(mPickUp)
                }}
                setDrop={mDrop => {
                  setDrop(mDrop)
                }}
              />
            </div>
            <button
              onClick={() => {
                handleCloseLocationPopup()
              }}
              className='trip-btn -dark-4 px-30 py-5 bg-dark-3 text-white'
              disabled={!pickup || !drop}
            >
              Submit
            </button>
          </Box>
        </Modal>

        <section className='carBookType rsl__Wrapper'>
          {/* Booking Content Start */}

          {
            modelListLoader ? <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{
                width: "100%",
                overflow: "hidden",
                py: 4,
                position: "relative",
              }}
            >
              {/* Left Arrow */}
              <IconButton
                sx={{
                  position: "absolute",
                  left: 16,
                  bgcolor: "linear-gradient(145deg, #0097a7, #00bcd4)",
                  color: "white",
                  boxShadow: 2,
                  "&:hover": { bgcolor: "#00acc1" },
                }}
              >
                <ArrowBackIcon fontSize="small" />
              </IconButton>

              {/* Skeleton Cards */}
              <Box
                display="flex"
                alignItems="center"
                gap={3}
                sx={{ overflow: "hidden", px: 6 }}
              >
                {[1, 2, 3, 4, 5].map((i) => (
                  <Box
                    key={i}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      width: 150,
                      height: 150,
                      borderRadius: 4,
                      border: i === 1 ? "2px solid #00bcd4" : "1px solid #e0e0e0",
                      backgroundColor: "#fff",
                      boxShadow: i === 1 ? 2 : 0,
                    }}
                  >
                    <Skeleton
                      variant="rounded"
                      width={80}
                      height={50}
                      sx={{ borderRadius: 2, mb: 1 }}
                    />
                    <Skeleton variant="text" width={60} height={20} />
                  </Box>
                ))}
              </Box>

              {/* Right Arrow */}
              <IconButton
                sx={{
                  position: "absolute",
                  right: 16,
                  bgcolor: "linear-gradient(145deg, #0097a7, #00bcd4)",
                  color: "white",
                  boxShadow: 2,
                  "&:hover": { bgcolor: "#00acc1" },
                }}
              >
                <ArrowForwardIcon fontSize="small" />
              </IconButton>
            </Box> :
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: "relative"
                }}
              >
                <ArrowBackIcon
                  className='cabmainArrow'
                  onClick={handlePrevious}
                  sx={navBtnSx("left")}
                />

                {/* Prev/Next (hide on mobile, show ≥md) */}
                {/* <IconButton className="cabmainArrow" aria-label="prev" sx={navBtnSx("left")}>
    <ArrowBackIcon />
  </IconButton>
  <IconButton className="fleet-next" aria-label="next" sx={navBtnSx("right")}>
    <ArrowForwardIcon />
  </IconButton> */}

                <div id='slick-slider' className='cabmainlist'>
                  <Slider ref={carouselRef} {...settings}>
                    {modelList?.map((item, index) => (
                      <CarouselItem
                        key={item.title}
                        item={item}
                        index={index}
                        setIndx={setIndx}
                        indx={indx}
                        modelList={modelList[index]}
                        setGetModelId={setGetModelId}
                        getModelId={getModelId}
                        modelIdget={modelIdget}
                      // handleFareCalculation={handleFareCalculation}
                      // changeImage={changeImage}
                      />
                    ))}
                  </Slider>
                </div>

                <ArrowForwardIcon
                  className='cabmainArrow'
                  onClick={handleNext}
                  sx={navBtnSx("right")}
                />
              </Box>
          }


          {/* <Box
            sx={{
              backgroundColor: '#f4f7fa',
              height: '20px',
              margin: '12px 0px'
            }}
          ></Box> */}

          <div className='booking-contents-cabs'>
            {/* Left */}

            {/* Right */}
            <div className='car-booking__cards'>
              {/* Menu */}
              {/* <div className="cars-header d-flex justify-end">
                <div className="btn col-auto d-none xl:d-block">
                  <button
                    data-bs-toggle="offcanvas"
                    data-bs-target="#carSidebar"
                    className="button -blue-1 h-40 px-20 rounded-100 bg-blue-1-05 text-15 text-white"
                  >
                    <i className="btn-1 icon-up-down text-14 mr-10" />
                    Filter
                  </button>
                </div>
              </div> */}
              {/* card */}
              <div style={{ marginTop: "40px" }} />
              {loader ? (
                <>
                  {Array.from({ length: 3 }).map((_, i) => (
                    <Card
                      key={i}
                      sx={{
                        p: { xs: 1.5, sm: 2 },
                        borderRadius: 3,
                        mb: { xs: 2, md: 3 }
                      }}
                      variant="outlined"
                    >
                      <Grid container spacing={2} alignItems="stretch" sx={{ position: 'relative' }}>
                        {/* Left: Car image */}
                        <Grid item xs={12} sm={4} md={3}>
                          <Box
                            sx={{
                              height: { xs: 120, sm: 140, md: 160 },
                              borderRadius: 3,
                              overflow: 'hidden',
                            }}
                          >
                            <Skeleton variant="rounded" height="100%" width="100%" />
                          </Box>
                        </Grid>

                        {/* Middle: Details */}
                        <Grid item xs={12} sm={8} md={6}>
                          <CardContent sx={{ p: 0, paddingBottom: "0px !important", height: '100%' }}>
                            <Stack spacing={1.5}>
                              {/* Title */}
                              <Skeleton variant="text" width="60%" height={32} />

                              <Box
                                sx={{
                                  border: '1px solid',
                                  borderColor: 'divider',
                                  borderRadius: 2,
                                  p: 1,
                                  mt: 0
                                }}
                              >
                                {/* Capacity row */}
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={2}
                                >
                                  <Skeleton variant="text" width={90} />
                                  <Skeleton variant="text" width={110} />
                                  <Skeleton variant="circular" width={8} height={8} />
                                  <Skeleton variant="text" width={100} />
                                </Stack>

                                <Divider sx={{ my: 0.5 }} />

                                {/* Fuel row */}
                                <Stack direction="row" alignItems="center" spacing={2}>
                                  <Skeleton variant="text" width={70} />
                                  <Skeleton variant="text" width={80} />
                                </Stack>

                                <Divider sx={{ my: 0.5 }} />

                                {/* Features row */}
                                <Stack direction="row" alignItems="center" spacing={2}>
                                  <Skeleton variant="text" width={90} />
                                  <Skeleton variant="circular" width={18} height={18} />
                                  <Skeleton variant="text" width={90} />
                                  <Skeleton variant="circular" width={18} height={18} />
                                  <Skeleton variant="text" width={90} />
                                  <Skeleton variant="circular" width={18} height={18} />
                                  <Skeleton variant="text" width={90} />
                                </Stack>
                              </Box>
                            </Stack>
                          </CardContent>
                        </Grid>

                        {/* Right: Price + CTA */}
                        <Grid
                          item
                          xs={12}
                          md={3}
                          display="flex"
                          justifyContent={{ xs: 'space-between', md: 'flex-end' }}
                          alignItems={{ xs: 'center', md: 'center' }}
                          gap={2}
                        >
                          <Stack
                            direction={{ xs: 'row', md: 'column' }}
                            alignItems={{ xs: 'center', md: 'flex-end' }}
                            justifyContent="center"
                            spacing={{ xs: 2, md: 3 }}
                            sx={{ width: '100%' }}
                          >
                            <Skeleton variant="text" width={120} height={40} />

                            <Box sx={{ width: { xs: 160, md: 180, position: "absolute", bottom: "0" } }}>
                              <Skeleton variant="rounded" width="100%" height={44} sx={{ borderRadius: "25px", }} />
                            </Box>
                          </Stack>
                        </Grid>
                      </Grid>
                    </Card>
                  ))}
                </>
              ) : !values || values?.length === 0 ? (
                <div className='no-data text-center pt-30'>
                  <div>
                    <img
                      src='/img/icons/noresults.png'
                      width='200'
                      height='200'
                    />
                    <p>{messages}</p>
                    {/* <p>Try modifying the City or Area</p> */}
                  </div>
                </div>
              ) : (
                values &&
                values.length !== 0 &&
                values?.map((item, index) => (
                  <>
                    <VehicleCard
                      title={item?.name}
                      image={`${process.env.IMAGE_BASE_URL}/${item?.image}`}
                      seats={item?.seat}
                      luggage={item?.baggage}
                      fuel="Petrol"
                      features={item?.features}
                      priceText={item?.price}
                      pricePerHour={item?.hourly_fare_per_hour}
                      onBook={handleConfirmBooking}
                      index={index}
                      modelId={item?.model_id}
                    />

                    {/* <div className='border p-3 rounded mb-3'>
                      <div className='car-main__section'>
                        <div
                          className='car-main__section_in'
                        >
                          <div className='car-main__image'>
                            <Image
                              width={150}
                              height={150}
                              src={`${process.env.IMAGE_BASE_URL}/${item?.image}`}
                              alt='car'
                            />
                          </div>
                          <div>
                            <span className='-dark-4  px-5 py-1 rounded-1 bg-dark-3 text-white car-main__label'>
                              Top Pick
                            </span>
                            <div className='my-3'>
                              <h6>
                                {item?.name}
                              </h6>
                              <p className='main-car__p'>{item?.description}</p>
                            </div>
                            <div className='main-car__facilities'>
                              {item?.seat && (
                                <div className='d-flex align-items-center'>
                                  <Image
                                    width={100}
                                    height={100}
                                    className='main-car__facilities_img'
                                    aspe
                                    src='/img/cars/icons/user.png'
                                    alt='car'
                                  />
                                  <p className='main-car__p'>
                                    {item?.seat} Seat
                                  </p>
                                </div>
                              )}
                              <div className='d-flex align-items-center'>
                                <Image
                                  width={100}
                                  height={100}
                                  className='main-car__facilities_img'
                                  aspe
                                  src='/img/cars/icons/largebag.png'
                                  alt='car'
                                />
                                <p className='main-car__p'>
                                  {item?.carDetails?.carcategory.tags.largebag}{' '}
                                  Large Bag
                                </p>
                              </div>
                              {item?.gearShift && (
                                <div className='d-flex align-items-center'>
                                  {item?.gearShift === 'both' ? (
                                    <>
                                      <Image
                                        width={100}
                                        height={100}
                                        className='main-car__facilities_img'
                                        aspe
                                        src='/img/cars/icons/automaticblack.png'
                                        alt='car'
                                      />
                                      <p className='main-car__p'>
                                        {item?.gearShift}
                                      </p>
                                    </>
                                  ) : (
                                    <>
                                      <Image
                                        width={100}
                                        height={100}
                                        className='main-car__facilities_img'
                                        aspe
                                        src='/img/cars/icons/manuall.png'
                                        alt='car'
                                      />
                                      <p className='main-car__p'>
                                        {item?.gearShift}
                                      </p>
                                    </>
                                  )}
                                </div>
                              )}
                              {item?.carDetails?.carcategory?.tags?.mileage && (
                                <div className='d-flex align-items-center'>
                                  <Image
                                    width={100}
                                    height={100}
                                    className='main-car__facilities_img'
                                    aspe
                                    src='/img/cars/icons/unlimitedmilage.png'
                                    alt='car'
                                  />
                                  <p className='main-car__p'>
                                    {item?.carDetails?.carcategory.tags.mileage}
                                  </p>
                                </div>
                              )}

                              <div className='d-flex align-items-center'>
                                <Image
                                  width={100}
                                  height={100}
                                  className='main-car__facilities_img'
                                  aspe
                                  src='/img/cars/icons/smallbag.png'
                                  alt='car'
                                />
                                <p className='main-car__p'>
                                  {item?.carDetails?.carcategory.tags.smallbag}{' '}
                                  Small Bag
                                </p>
                              </div>
                            </div>
                            <div className='mt-3'>
                              <h6 className='text-info'>{item?.cityName}</h6>
                            </div>
                          </div>
                        </div>
                        <div className='d-flex align-items-end flex-sm-row flex-md-column justify-content-between y-gap-20'>
                          <div>
                            <h4>
                              {item?.currency} {item?.price}
                            </h4>
                          </div>
                          <div>
                            <div className='trip-btns'>
                              <button
                                onClick={() => {
                                  // handleBooking(index, item?.model_id);
                                  handleConfirmBooking(index, item?.model_id)
                                  // alert("Book Now", index, item?.model_id);
                                }}
                                // disabled={JSON.parse(sessionStorage.getItem("phone")) === "" ? true : false}
                                className='trip-btn button -dark-4 px-30 py-5 bg-dark-3 text-white'
                              >
                                Book Now
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </>
                ))
              )}
            </div>
          </div>
        </section>

        {paymentOpen &&
          <Dialog
            fullWidth={true}
            className="text-center"
            keepMounted
            maxWidth="md"
            open={paymentOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"

          >
            {/* close */}
            <IconButton onClick={handleCancelPayment} sx={{ position: "absolute", top: 8, right: 8 }}>
              <CancelIcon />
            </IconButton>
            {
              errorMessage && errorMessage?.status !== 1 ? "" :
                <DialogTitle className='jura' sx={{ textAlign: "center", fontWeight: 600 }}>
                  How would you like to pay?
                </DialogTitle>
            }
            {/* <DialogActions className="mt-5 mb-5 items-center justify-between d-flex">
              {
                errorMessage && errorMessage?.status !== 1 ? "" :
                  <Typography
                    className="fw-bold"
                    variant="h6"
                    sx={{
                      fontSize: { xs: "16px", sm: "18px", md: "20px", lg: "24px" }, // Adjust for different screen sizes
                      justifyContent: "center !important"
                    }}
                  >
                    How would you like to pay?
                  </Typography>
              }

            </DialogActions> */}
            {
              errorMessage && errorMessage?.status !== 1 ? "" :
                <hr style={{
                  margin: '0px'
                }} />
            }



            {
              errorMessage && errorMessage?.status !== 1 ?
                <ErrorPage handleClose={() => window.location.reload()} errorMessage={errorMessage} /> :
                <Box sx={{
                  padding: 4,
                }}>
                  <PaymentModes
                    open={paymentOpen}
                    setPaymentMode={setPaymentMode}
                    setTransRef={setTransRef}
                    paymentMode={paymentMode}
                    bookingLoader={bookingLoader}
                    handleCardOption={() => handleCardOption()}
                    price={price}
                    handleClose={() => handleCancelPayment()}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                  />
                </Box>
            }

          </Dialog>
        }

        <Dialog
          open={open}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
          disableBackdropClick
          disableEscapeKeyDown
          PaperProps={{
            sx: {
              borderRadius: "20px",
              border: "10px solid #0D8196"
            },
          }}

        >
          <DialogTitle id='alert-dialog-title' style={{ color: "#097285" }}>
            Are you sure you want to book this ride?
          </DialogTitle>
          <DialogContent style={{ width: "480px" }}>
            {/* Close Button */}
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                border: "1px solid #9ED4CC",
                borderRadius: "8px",
                color: "#007C84",
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
            <DialogContentText id='alert-dialog-description'>
              <Box>
                <Box sx={{ my: 2 }}>
                  <Grid container alignItems="start" spacing={1}>
                    {/* Label */}
                    <Grid item xs="auto">
                      <Typography
                        sx={{
                          color: "#0D8196",
                          fontWeight: 600,
                          fontSize: "16px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Pick Up:
                      </Typography>
                    </Grid>

                    {/* Gradient Text */}
                    <Grid item xs>
                      <Typography
                        component="strong"
                        sx={{
                          background: "linear-gradient(90deg, #75C4C5 0%, #0D8196 100%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          fontWeight: 700,
                          fontSize: "16px",
                          display: "block",
                        }}
                      >
                        {pickup}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Grid container alignItems="start" spacing={1}>
                    {/* Label */}
                    <Grid item xs="auto">
                      <Typography
                        sx={{
                          color: "#0D8196",
                          fontWeight: 600,
                          fontSize: "16px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Drop Off:
                      </Typography>
                    </Grid>

                    {/* Gradient text value */}
                    <Grid item xs>
                      <Typography
                        component="strong"
                        sx={{
                          background: "linear-gradient(90deg, #75C4C5 0%, #0D8196 100%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          fontWeight: 700,
                          fontSize: "16px",
                          display: "block",
                        }}
                      >
                        {drop}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Grid container alignItems="start" spacing={1}>
                    {/* Label */}
                    <Grid item xs="auto">
                      <Typography
                        sx={{
                          color: "#0D8196",
                          fontWeight: 600,
                          fontSize: "16px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Model:
                      </Typography>
                    </Grid>

                    {/* Gradient Text */}
                    <Grid item xs>
                      <Typography
                        component="strong"
                        sx={{
                          background: "linear-gradient(90deg, #75C4C5 0%, #0D8196 100%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          fontWeight: 700,
                          fontSize: "16px",
                          display: "block",
                        }}
                      >
                        {selectedModelName}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {/* {!bookingLoader ? (
              <Button onClick={handleClose} color='primary'
                style={{
                  border: "1px solid #0D8196",
                  borderRadius: "20px"
                }}
              >
                Cancel
              </Button>
            ) : (
              ''
            )} */}

            <CtaButton label="Confirm" onClick={handleBooking} loader={bookingLoader} />
          </DialogActions>
        </Dialog>

        <Dialog
          open={openLocation}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
          disableBackdropClick
          disableEscapeKeyDown
        >
          <DialogTitle id='alert-dialog-title'>
            Please select the location
          </DialogTitle>

          <DialogActions>
            <Button onClick={handleCloseLocation} color='primary'>
              Okay
            </Button>
          </DialogActions>
        </Dialog>

        <div
          className={`currencyMenu js-currencyMenu ${click ? '' : 'is-hidden'}`}
        >
          <div className='currencyMenu__bg' onClick={handleCurrency}></div>
          <div className='currencyMenu__signpop bg-white rounded-4'>
            <div className='d-flex items-center justify-between px-30 py-20 sm:px-15 border-bottom-light'>
              {/* End Title */}
              <div />

              <button className='pointer' onClick={handleCurrency}>
                <i className='icon-close' />
              </button>
              {/* End colse button */}
            </div>
            {/* End flex wrapper */}
            <div
              className='text-20 fw-500 lh-15 px-30  py-30 sm:px-15 sm:py-15'
              style={{
                textAlign: 'center'
              }}
            >
              {safeParseJSON('rslkey') &&
                !safeParseJSON('phone')
                ? 'To continue Booking, please Update Your Mobile Number'
                : 'To continue Booking, please Sign in to your account'}
            </div>
            <div
              className='px-30  py-30 sm:px-15 sm:py-15'
              style={{
                textAlign: 'center'
              }}
            >
              {/* {JSON.parse(sessionStorage.getItem("phone")) === "" ? ( */}
              {safeParseJSON('rslkey') &&
                !safeParseJSON('phone') ? (
                <>
                  <div className='col-md-12'>
                    <div className='row x-gap-0'>
                      <div className='col-sm-4 border'>
                        <label
                          className='lh-1 text-16 text-light-1 px-2'
                          style={{
                            marginLeft: '-80px'
                          }}
                        >
                          Code
                        </label>
                        <div className=''>
                          {/* <label className="lh-1 text-16 text-light-1">Code</label> */}
                          <Autocomplete
                            defaultValue={defaultCode}
                            name="countryCode"
                            ref={ref0}
                            onChange={(e, newValue) => handleChange(e, newValue?.phone || "")}
                            freeSolo
                            disableClearable
                            options={countries}
                            autoHighlight
                            getOptionLabel={(option) =>
                              typeof option === "string" ? option : `${option.code}+${option.phone}`
                            }
                            renderOption={(props, option) => (
                              <li {...props}>
                                <span>{countryToFlag(option.code)}</span>&nbsp;
                                {option.label} ({option.code}) +{option.phone}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                placeholder="AE+971"
                                onClick={(params) => (params.target.value = "")}
                                variant="standard"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "new-password", // disable autocomplete and autofill
                                }}
                              />
                            )}
                            sx={{
                              width: "100%",
                              "& .MuiAutocomplete-paper": {
                                width: "300px",
                              },
                              "& .MuiAutocomplete-inputRoot": {
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 0,
                                border: "none",
                                pl: "12px", // replaces paddingLeft
                              },
                              "& .MuiAutocomplete-input": {
                                // fontSize: "14px",
                                // padding: "6px",
                              },
                              "& .MuiAutocomplete-option": {
                                // backgroundColor: "green",
                              },
                            }}
                          />

                        </div>
                      </div>
                      <div className='col-sm-8'>
                        <div className='form-input '>
                          <input
                            type='text'
                            required
                            name='number'
                            maxLength={
                              defaultCode ? defaultCode.maxlength : undefined
                            }
                            value={userNumber.number}
                            onChange={e => handleChange(e)}
                            onInput={e =>
                            (e.target.value = e.target.value
                              .replace(/[^0-9.]/g, '')
                              .replace(/(\..*)\./g, '$1'))
                            }
                          />
                          <label className='lh-1 text-16 text-light-1'>
                            Phone Number
                          </label>
                        </div>
                        {/* {errors.phone ? (
                          <p style={{
                            color: validate ? "red" : "white",
                          }}>
                            {errors.phone}
                          </p>
                        ) : (
                          ""
                        )} */}
                      </div>
                    </div>
                  </div>
                  <button
                    className='btn bg-dark-3 mt-3 text-white'
                    type='button'
                    onClick={() => {
                      handleUpdate()
                    }}
                  >
                    Update Profile
                  </button>
                </>
              ) : (
                <button
                  className='btn bg-dark-3 text-white'
                  onClick={() => {
                    // router.push("/sign-in/sign-in");
                    sessionStorage.setItem('isSig', true)
                    setClick(false)
                  }}
                >
                  Sign In
                </button>
              )}
            </div>
          </div>
        </div>

      </Box>
      <Footer3 bgcolor="#f8f8f8" />
    </>
  )
}

/* Prev/Next buttons: hidden on mobile, tuned on desktop */
const navBtnSx = (side) => ({
  position: "absolute",
  zIndex: 2,
  top: { xs: "38%", md: "45%" },
  [side]: { xs: 4, md: -50 },
  transform: side === "left" ? "translateX(-10%)" : "translateX(10%)",
  width: { xs: 36, md: 40 },
  height: { xs: 36, md: 40 },
  display: { xs: "none", md: "flex" }, // hide on mobile
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  background: "linear-gradient(180deg, #75c4c5 0%, #0d8196 100%)",
  color: "#fff",
  boxShadow: "0 8px 24px rgba(0,0,0,.25)",
  border: "none",
  padding: "6px",
  "&:hover": { background: "linear-gradient(180deg, #4bb6b4 0%, #249f9c 100%)" },
});

export default CarBookRide

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}